import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon_left.png';
import _imports_1 from '../../assets/icon_right.png';
import _imports_2 from '../../assets/icon_device1.png';
import _imports_3 from '../../assets/icon_device2.png';
import _imports_4 from '../../assets/icon_device3.png';
import _imports_5 from '../../assets/block2_img3.png';
import _imports_6 from '../../assets/block2_img1.png';
import _imports_7 from '../../assets/block2_img2.png';
import _imports_8 from '../../assets/block3_img.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1eba9530"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top",
  id: "content"
};
var _hoisted_2 = ["src"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon"
  }, null, -1);
});

var _hoisted_4 = [_hoisted_3];

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "icon"
  }, null, -1);
});

var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = {
  key: 0,
  class: "animate__fadeIn"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_title animated fadeInUp"
  }, [/*#__PURE__*/_createTextVNode(" 类纸阅读全新体验 "), /*#__PURE__*/_createElementVNode("div", {
    class: "banner_line"
  })], -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_abs animated fadeInUp"
  }, [/*#__PURE__*/_createTextVNode(" 致力于成为 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 一流的儿童健康阅读服务供给商 ")], -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_last1 animated fadeIn"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "banner_block"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "banner_English"
  }, "A NEW READING EXPERIENCE LIKE A BOOK")], -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_last2 animated fadeIn"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "banner_block"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "banner_English"
  }, "HOPEFULLY READING WILL BECOME A HABIT IN YOUR LIFE")], -1);
});

var _hoisted_12 = [_hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11];
var _hoisted_13 = {
  class: "indicator"
};
var _hoisted_14 = {
  key: 0,
  class: "indicator2"
};
var _hoisted_15 = {
  key: 2,
  class: "indicator2"
};

var _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"block\" data-v-1eba9530><div class=\"block_part1\" data-v-1eba9530><img src=\"" + _imports_2 + "\" class=\"device_img\" data-v-1eba9530><div class=\"device_text1\" data-v-1eba9530>百城绘本馆</div><div class=\"device_text2\" data-v-1eba9530> 适用于儿童的内容、软件、硬件平台 <br data-v-1eba9530> 为儿童提供丰富的彩色绘本阅读体验 </div></div><div class=\"block_part2\" data-v-1eba9530><img src=\"" + _imports_3 + "\" class=\"device_img\" data-v-1eba9530><div class=\"device_text1\" data-v-1eba9530>百城启明星</div><div class=\"device_text2\" data-v-1eba9530> 本系列产品适用与中少年及成人广谱阅读，以及 <br data-v-1eba9530> 书写涂鸦等专业领域，系统成熟稳定 </div></div><div class=\"block_part1\" data-v-1eba9530><img src=\"" + _imports_4 + "\" class=\"device_img\" data-v-1eba9530><div class=\"device_text1\" data-v-1eba9530>电子平板纸</div><div class=\"device_text2\" data-v-1eba9530> 基于我们的硬件集成、软件系统研发能力与 <br data-v-1eba9530> 行业伙伴合作开发平拍内容的联名产品。 </div></div></div>", 1);

var _hoisted_17 = {
  class: "block2"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block2_title"
  }, " COMPANY PROFILE ", -1);
});

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block2_title2"
  }, " 关于我们 ", -1);
});

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block2_border"
  }, null, -1);
});

var _hoisted_21 = {
  class: "block2_content"
};

var _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"block2_content_title\" data-v-1eba9530>杭州百城智联科技有限公司</div><div class=\"block2_content_content\" data-v-1eba9530> 百城智联致力基于彩色电子纸（彩色墨水屏）显示技术的儿童专用健康平板研发、订制；儿童融媒体数字阅读、教育、娱乐 <br data-v-1eba9530> 平台服务与内容分发；彩色电子纸阅读终端研发推广。 <br data-v-1eba9530> 我们整合产业优质资源，为行业准备好基础硬件、内容和服务平台，以及相关子系统。我们力求发挥自身优势，携手业界同 <br data-v-1eba9530> 仁，共同打造全新的产业体系。 </div><div class=\"li\" data-v-1eba9530><div class=\"circle\" data-v-1eba9530></div><div class=\"li_text\" data-v-1eba9530>行业先进技术掌握者--领导者也是互联网创新，公司业务涉及大数据、智能多媒体、物联网、云计算等等。</div></div><div class=\"li\" data-v-1eba9530><div class=\"circle\" data-v-1eba9530></div><div class=\"li_text\" data-v-1eba9530>科技创新集团-- 领导者也是互联网创新，公司业务涉及大数据、智能多媒体、物联网、云计算等等。</div></div><div class=\"li\" data-v-1eba9530><div class=\"circle\" data-v-1eba9530></div><div class=\"li_text\" data-v-1eba9530>头部资源与先进技术的集成者--成员具备高校数字阅读与数字教育领域多年从业经验；</div></div><div class=\"li\" data-v-1eba9530><div class=\"circle\" data-v-1eba9530></div><div class=\"li_text\" data-v-1eba9530>专业源于专注--具备完善的内容、管理、社交阅读等子系统；可与不同应用场景、不同需求的用户深度合作……</div></div><div class=\"li\" data-v-1eba9530><div class=\"circle\" data-v-1eba9530></div><div class=\"li_text\" data-v-1eba9530>携手共进、海纳百川的创业公司--携手内容制作与出版单位，销售企业及相关应用单位，力求共同建设有声有色、开放创新的数字阅读新体系。</div></div>", 7);

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block2_btn_text"
  }, "公司简介", -1);
});

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "block_img3"
  }, null, -1);
});

var _hoisted_31 = [_hoisted_29, _hoisted_30];

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "block2_img1"
  }, null, -1);
});

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_cover"
  }, null, -1);
});

var _hoisted_34 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "block2_img2"
  }, null, -1);
});

var _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"block3\" data-v-1eba9530><img src=\"" + _imports_8 + "\" class=\"block3_img\" data-v-1eba9530><div class=\"block3_title\" data-v-1eba9530><div class=\"block3_title1\" data-v-1eba9530> “ 希望健康阅读能够滋养你的野蛮生长终会成为一颗枝繁茂叶的白杨树 ” </div><div class=\"block3_title2\" data-v-1eba9530> Hopefully, healthy reading will nourish your savage growth and eventually become a leafy poplar tree. </div></div></div><div class=\"block4\" data-v-1eba9530><div class=\"block2_title\" data-v-1eba9530> PRODUCT SERVICES </div><div class=\"block2_title2\" data-v-1eba9530> 产品服务 </div><div class=\"block2_border\" data-v-1eba9530></div><div class=\"block4_content\" data-v-1eba9530><div class=\"block4_contnt2\" data-v-1eba9530><div class=\"block4_content1\" data-v-1eba9530><div class=\"block4_content1_title\" data-v-1eba9530>儿童专用健康阅读平板</div><div class=\"block4_content1_content\" data-v-1eba9530> 儿童专用健康阅读平板基于全球公认唯一健康显示技术 --彩色电子纸（墨水屏）的儿童专用健康平板。无蓝光 辐射；支持音视频海量绘本，儿歌动漫、益智游戏和小 学读物；标配互联网4G支持在线娱乐智能测验、讲故事 背诗词和绘画书写等支持第三方内容和应用适配。 </div></div></div><div class=\"block4_contnt2\" data-v-1eba9530><div class=\"block4_content1\" data-v-1eba9530><div class=\"block4_content1_title\" data-v-1eba9530>彩色电子书</div><div class=\"block4_content1_content\" data-v-1eba9530> 电子墨水显示和电纸书润目护眼、无辐射、低功耗，有类 似纸张的阅读体验和数字网络产品的快速更新、智能化使 用的特征，自欧美到中国，迅速普及。 </div></div></div><div class=\"block4_contnt2\" data-v-1eba9530><div class=\"block4_content1\" data-v-1eba9530><div class=\"block4_content1_title\" data-v-1eba9530>儿童融媒体阅读平台</div><div class=\"block4_content1_content\" data-v-1eba9530> 集在线书城、管理、服务于一体的儿童专用多媒体数字内 容平台。业界领军的儿童内容出版机构和内容制作企业联 袂奉献0-12岁儿童分级阅读内容、益智游戏应用、交互式 阅读应用等共约10万册（部、个）。 </div></div></div><div class=\"block4_contnt2\" data-v-1eba9530><div class=\"block4_content1\" data-v-1eba9530><div class=\"block4_content1_title\" data-v-1eba9530>阅读行为分析</div><div class=\"block4_content1_content\" data-v-1eba9530> 百城智联自主研发，阅读终端智能侦测模块与平台大数 据分析结合，构成阅读行为分析系统。本系统面向用户 幼儿园和学校等管理机构，输出个人、集体的各种阅读 数据。系统可以直接布置到第三方平台或终端。 </div></div></div><div class=\"block4_contnt2\" data-v-1eba9530><div class=\"block4_content1\" data-v-1eba9530><div class=\"block4_content1_title\" data-v-1eba9530>彩色电子纸（墨水屏）经销</div><div class=\"block4_content1_content\" data-v-1eba9530> 业界领先的彩色电子纸厂商独家授权，在中国（大陆地区 ）代理销售4.5寸到25寸数十种规格彩色电子纸产品。附赠 公模，可通过联合品牌定制，免除各项认证手续。 </div></div></div><div class=\"block4_contnt2\" data-v-1eba9530><div class=\"block4_content1\" data-v-1eba9530><div class=\"block4_content1_title\" data-v-1eba9530>基于微信的社交阅读系统</div><div class=\"block4_content1_content\" data-v-1eba9530> 打通儿童专用健康平板、电纸书与手机，通过微信等社交 工具交流阅读心得，共享图书、（百城）“圈子”里选定 的作品、动漫游戏等，通过手机直接推送至彩色电子纸终 端；可查询个人、平台的阅读数据；儿童讲故事、书画涂 鸦等直接上传家长手机，可通过微信分享…… </div></div></div></div></div>", 2);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    interval: 5000,
    "indicator-position": "none",
    arrow: "never",
    ref: "topbanner",
    onChange: _ctx.changeItem
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, function (item, index) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: index,
          class: "aaa"
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item.url,
              class: "banner"
            }, null, 8, _hoisted_2), _createElementVNode("div", {
              class: "pre",
              onClick: _cache[0] || (_cache[0] = function () {
                return _ctx.pre && _ctx.pre.apply(_ctx, arguments);
              })
            }, _hoisted_4), _createElementVNode("div", {
              class: "next",
              onClick: _cache[1] || (_cache[1] = function () {
                return _ctx.next && _ctx.next.apply(_ctx, arguments);
              })
            }, _hoisted_6), item.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_12)) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1024);
      }), 128)), _createElementVNode("div", _hoisted_13, [_ctx.banner_active == 0 || _ctx.banner_active == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_14)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "indicator1",
        onClick: _cache[2] || (_cache[2] = function () {
          return _ctx.pre && _ctx.pre.apply(_ctx, arguments);
        })
      })), _ctx.banner_active == 1 || _ctx.banner_active == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_15)) : (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "indicator1",
        onClick: _cache[3] || (_cache[3] = function () {
          return _ctx.next && _ctx.next.apply(_ctx, arguments);
        })
      }))])];
    }),
    _: 1
  }, 8, ["onChange"])]), _hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _hoisted_19, _hoisted_20, _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", {
    class: "block2_btn",
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.handleIntroduction && _ctx.handleIntroduction.apply(_ctx, arguments);
    })
  }, _hoisted_31), _hoisted_32, _hoisted_33, _hoisted_34])]), _hoisted_35], 64);
}